/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AppControllerHandleEvent_3$Params {
}

export function appControllerHandleEvent_3(http: HttpClient, rootUrl: string, params?: AppControllerHandleEvent_3$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, appControllerHandleEvent_3.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'message'?: string;
      }>;
    })
  );
}

appControllerHandleEvent_3.PATH = '/thalea-google-events/events/handler';
